import React from 'react'
import { Link } from 'gatsby'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import { format } from 'date-fns'
import PortableText from '../../portableText'
import MarketoForm from '../../Marketo/MktoForm'
import { BlogHeroContainer, BlogHeroCopyContainer, FeaturedBlogContainer } from './BlogHero.styles'

export default function BlogHero({ blurb, featuredBlog, marketoForm, title }) {
	const BlogHeroCopy = ({ portableTextBlock }) => <PortableText blocks={portableTextBlock} />
	const { postTitle, mainImage, publishedAt, slug } = featuredBlog
	const date = new Date(publishedAt)
	const formattedDate = format(date, 'MMMM Do, YYYY')

	return (
		<BlogHeroContainer>
			<Link to={`/blog-under-construction/${slug.current}`}>
				<FeaturedBlogContainer>
					<SanityImage asset={mainImage.asset} alt={mainImage.alt} {...mainImage} />
					<div>
						<time dateTime={publishedAt}>{formattedDate}</time>
						<h3>{postTitle}</h3>
					</div>
				</FeaturedBlogContainer>
			</Link>
			<BlogHeroCopyContainer>
				<h1>{title}</h1>
				<BlogHeroCopy {...blurb} />
				{marketoForm && <MarketoForm {...marketoForm} />}
			</BlogHeroCopyContainer>
		</BlogHeroContainer>
	)
}

BlogHero.propTypes = {
	title: PropTypes.string,
	marketoForm: PropTypes.object,
	blurb: PropTypes.object,
	portableTextBlock: PropTypes.array,
	featuredBlog: PropTypes.object,
}
